import PubSub from 'underpub-js';
import gsap from 'gsap';

var VideoBlock = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'comp-VideoBlock',
  };

  $.extend(true, this.options, options);
};

VideoBlock.prototype.init = function() {
  const self = this;

  self.$overlay = self.options.$el.find(
    `.${self.data.baseClass}__video__overlay`,
  );
  self.$cta = self.options.$el.find(`.${self.data.baseClass}__video__cta`);
  self.$thumbnail = self.options.$el.find(
    `.${self.data.baseClass}__video__thumbnail`,
  );
  self.$embed = self.options.$el.find(`.${self.data.baseClass}__video__embed`);
  self.$iframe = self.$embed.find('iframe');
  self.iframeSrc = self.$iframe.attr('src');

  self.handleVideoPlay();
};

VideoBlock.prototype.handleVideoPlay = function() {
  const self = this;

  const videoPlayTL = gsap
    .timeline({ paused: true })
    .to(self.$cta, {
      duration: 0.2,
      ease: 'expo.easeout',
      opacity: 0,
      yPercent: 100,
      skewX: -15,
      xPercent: -5,
    })
    .to(
      self.$overlay,
      {
        duration: 0.3,
        ease: 'expo.easeout',
        autoAlpha: 0,
      },
      '<',
    )
    .to(
      self.$thumbnail,
      {
        duration: 1,
        ease: 'expo.easeout',
        autoAlpha: 0,
      },
      '>.3',
    )
    .add(() => {
      self.$iframe.attr('src', `${self.iframeSrc}?autoplay=1`);
    }, '<');

  self.$overlay.on('click', () => videoPlayTL.play());
};

export default VideoBlock;
